const TECLAS_ANTERIOR = ["ArrowLeft", "ArrowUp", "Left", "Up"];
const TECLAS_PROXIMA = ["ArrowRight", "ArrowDown", "Right", "Down"];

let contador = 0;

function abasDe(el) {
  return Array.from(el.querySelectorAll('[role="tab"]'));
}

function containerDasAbas(el) {
  return (
    el.querySelector('[role="tablist"]') ||
    el.querySelector(".v-slide-group__content") ||
    el.querySelector(".v-tabs-bar__content") ||
    el
  );
}

function containerDosPaineis(el) {
  const pai = el.parentElement;
  if (!pai) return null;
  return (
    Array.from(pai.children).find(
      filho => filho !== el && filho.classList.contains("v-window")
    ) || pai.querySelector(".v-window")
  );
}

function habilitada(aba) {
  return (
    aba.getAttribute("aria-disabled") !== "true" &&
    !aba.classList.contains("v-tab--disabled") &&
    !aba.hasAttribute("disabled")
  );
}

function abaSelecionada(abas) {
  return abas.find(a => a.getAttribute("aria-selected") === "true") || null;
}

function aplicarRoving(abas) {
  const focada = abas.find(a => a === document.activeElement);
  const referencia = focada || abaSelecionada(abas) || abas.find(habilitada);
  abas.forEach(aba => {
    aba.setAttribute("tabindex", aba === referencia ? "0" : "-1");
  });
  return referencia;
}

function marcarEstrutura(el, rotulo) {
  const abas = abasDe(el);
  if (!abas.length) return;

  if (!el.__abasId) el.__abasId = `abas-${++contador}`;
  const base = el.__abasId;

  const lista = containerDasAbas(el);
  if (lista.getAttribute("role") !== "tablist") {
    lista.setAttribute("role", "tablist");
  }
  if (rotulo) lista.setAttribute("aria-label", rotulo);

  el.querySelectorAll(
    ".v-tabs-slider-wrapper, .v-slide-group__prev, .v-slide-group__next"
  ).forEach(nodo => nodo.setAttribute("role", "presentation"));

  const paineis = containerDosPaineis(el);
  if (paineis && !paineis.id) paineis.id = `${base}-paineis`;

  abas.forEach((aba, i) => {
    if (!aba.id) aba.id = `${base}-aba-${i}`;
    if (paineis) aba.setAttribute("aria-controls", paineis.id);
  });
}

function marcarPainel(el) {
  const paineis = containerDosPaineis(el);
  if (!paineis) return;

  const abas = abasDe(el);
  const ativa = abaSelecionada(abas) || abas[0];

  paineis.querySelectorAll(".v-window-item").forEach(nodo => {
    nodo.removeAttribute("role");
    nodo.removeAttribute("tabindex");
    nodo.removeAttribute("aria-labelledby");
  });

  const painel =
    paineis.querySelector(".v-window-item--active") ||
    paineis.querySelector(".v-window-item");
  if (!painel) return;

  painel.setAttribute("role", "tabpanel");
  painel.setAttribute("tabindex", "0");
  if (ativa && ativa.id) painel.setAttribute("aria-labelledby", ativa.id);
}

function sincronizar(el, rotulo) {
  marcarEstrutura(el, rotulo);
  aplicarRoving(abasDe(el));
  marcarPainel(el);
}

function aoTeclar(el, rotulo) {
  return function (evento) {
    const abas = abasDe(el).filter(habilitada);
    if (!abas.length) return;

    const atual = abas.indexOf(document.activeElement);
    if (atual === -1) return;

    let destino = null;
    if (TECLAS_PROXIMA.includes(evento.key)) destino = (atual + 1) % abas.length;
    else if (TECLAS_ANTERIOR.includes(evento.key))
      destino = (atual - 1 + abas.length) % abas.length;
    else if (evento.key === "Home") destino = 0;
    else if (evento.key === "End") destino = abas.length - 1;
    if (destino === null) return;

    evento.preventDefault();
    abas[destino].focus();
    abas[destino].click();
    sincronizar(el, rotulo);
  };
}

function observar(el) {
  const observador = new MutationObserver(() => {
    aplicarRoving(abasDe(el));
    marcarPainel(el);
  });

  const lista = containerDasAbas(el);
  observador.observe(lista, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["aria-selected", "class"],
  });

  const paineis = containerDosPaineis(el);
  if (paineis) {
    observador.observe(paineis, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  return observador;
}

export default {
  inserted(el, binding) {
    const rotulo = binding.value;

    el.__abasHandler = aoTeclar(el, rotulo);
    el.addEventListener("keydown", el.__abasHandler);

    el.__abasFocus = () => aplicarRoving(abasDe(el));
    el.addEventListener("focusin", el.__abasFocus);

    sincronizar(el, rotulo);
    el.__abasObserver = observar(el);
  },
  componentUpdated(el, binding) {
    sincronizar(el, binding.value);
  },
  unbind(el) {
    if (el.__abasHandler) el.removeEventListener("keydown", el.__abasHandler);
    if (el.__abasFocus) el.removeEventListener("focusin", el.__abasFocus);
    if (el.__abasObserver) el.__abasObserver.disconnect();
    delete el.__abasHandler;
    delete el.__abasFocus;
    delete el.__abasObserver;
    delete el.__abasId;
  },
};
